export const types = {
  ADD_CARD: "ADD_CARD",
  DRAG_HAPPENDED: "DRAG_HAPPENDED",
  EDIT_CARD: "EDIT_CARD",
  DELETE_CARD: "DELETE_CARD",
  SET_LIST: "SET_LIST"
};
